import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, race } from 'rxjs';
import { defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { currentEncounterId, isEmptyEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { PhysicalExaminationState } from '../../entities';
import { PhysicalExaminationApi } from '../../infrastructure';
import { PhysicalExaminationAction } from '../actions';

/**
 * Physical examination effects
 */
@Injectable()
export class PhysicalExaminationEffects {
    /* Effect Declarations */

    /**
     * Load physical examination effect
     */

    loadPhysicalExamination$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PhysicalExaminationAction.loadPhysicalExaminationAction.action),
            switchMap(action =>
                race(
                    isEmptyEncounterId(this.store).pipe(
                        take(1),
                        map(() => PhysicalExaminationAction.loadPhysicalExaminationAction.clearAction()),
                    ),
                    from(
                        makeDefaultAsyncActionEffect(
                            this.physicalExaminationApi
                                .getPhysicalExaminations(action.encounterId)
                                .pipe(isSameEncounterFilter(currentEncounterId(this.store), action.encounterId)),
                            PhysicalExaminationAction.loadPhysicalExaminationAction,
                        ),
                    ).pipe(defaultIfEmpty(PhysicalExaminationAction.loadPhysicalExaminationAction.clearAction())),
                ),
            ),
        ),
    );

    /**
     * Constructor
     * @param actions$ Actions
     * @param physicalExaminationApi PhysicalExaminationApi
     * @param store Store<PhysicalExaminationState>
     */
    constructor(
        private actions$: Actions,
        private physicalExaminationApi: PhysicalExaminationApi,
        private store: Store<PhysicalExaminationState>,
    ) {}
}
